export default __webpack_public_path__ + "static/media/bulk-parent.95956e62.csv";